const insuranceDataSource = {
  insuranceProjects: [
    {
      id: 1,
      projectName: '北京科技有限公司项目',
      customerName: '北京科技有限公司',
      department: ['华北运营中心', '业务部'],
      projectAddress: ['北京市', '市辖区', '朝阳区'],
      addressDetail: '科技园区A座',
      projectManager: '张三',
      customerManager: '李四',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '科技',
      actualEmployer: '平台',
      remark: '年度续保项目',
      createTime: '2024-01-15T10:00:00Z',
      updateTime: '2024-01-15T10:00:00Z',
      children: [
        {
          id: 101,
          productName: '团体意外保险A款',
          insurancePackage: '套餐A',
          policyNumber: 'POL2024001001',
          insuranceCompany: '太平洋保险',
          salesPrice: '120',
          effectiveStartDate: '2024-02-01',
          effectiveEndDate: '2025-01-31',
          effectiveDate: '2024-02-01 ~ 2025-01-31',
          customerManager: '李四',
          workLocation: ['北京市', '朝阳区'],
          projectType: '科技研发',
          billingCycle: '月度',
          accountingEntity: '北京科技有限公司',
          accountingSubject: '北京总公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'XX人力资源有限公司',
          platformInsurance: '是',
          customerService: '李晓华',
          employmentType: ['正式员工', '实习生'],
          position: ['技术', '管理'],
          maxInsuranceCount: 100,
          projectAddress: ['北京市', '市辖区', '朝阳区'],
          addressDetail: '科技园区A座',
          policies: [
            {
              policyNo: 'POL2024001001',
              policyHolder: '北京科技有限公司',
              insured: ['全体正式员工', '实习生'],
              effectiveDate: '2024-02-01 ~ 2025-01-31',
              salesPrice: '120元/人/月',
              costPrice: '96元/人/月',
              insuranceCompany: '太平洋保险',
              insuranceType: '团体意外险',
              insuranceName: '太平洋团体意外伤害保险'
            }
          ]
        },
        {
          id: 102,
          productName: '团体医疗健康险B款',
          insurancePackage: '套餐B',
          policyNumber: 'POL2024002001',
          insuranceCompany: '平安保险',
          salesPrice: '150',
          effectiveStartDate: '2024-03-01',
          effectiveEndDate: '2025-02-28',
          effectiveDate: '2024-03-01 ~ 2025-02-28',
          customerManager: '李四',
          workLocation: ['北京市', '海淀区'],
          projectType: '科技研发',
          billingCycle: '季度',
          accountingEntity: '北京科技有限公司',
          accountingSubject: '北京总公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'YY灵活用工平台',
          platformInsurance: '否',
          customerService: '赵文静',
          employmentType: ['正式员工'],
          position: ['全体员工'],
          maxInsuranceCount: 50,
          projectAddress: ['北京市', '市辖区', '海淀区'],
          addressDetail: '中关村科技园',
          policies: [
            {
              policyNo: 'POL2024002001',
              policyHolder: '北京科技有限公司',
              insured: ['全体正式员工'],
              effectiveDate: '2024-03-01 ~ 2025-02-28',
              salesPrice: '150元/人/月',
              costPrice: '120元/人/月',
              insuranceCompany: '平安保险',
              insuranceType: '团体医疗险',
              insuranceName: '平安团体医疗保险'
            }
          ]
        }
      ]
    },
    {
      id: 2,
      projectName: '上海物流配送项目',
      customerName: '顺丰速运有限公司',
      department: ['华东运营中心', '业务部'],
      projectAddress: ['上海市', '市辖区', '浦东新区'],
      addressDetail: '物流园区B区',
      projectManager: '王五',
      customerManager: '赵六',
      businessType: '物流保险',
      cooperationStatus: '合作中',
      industry: '快递物流',
      actualEmployer: '客户',
      remark: '物流配送专项保险',
      createTime: '2024-02-20T14:30:00Z',
      updateTime: '2024-02-20T14:30:00Z',
      children: [
        {
          id: 201,
          productName: '物流人员意外险',
          insurancePackage: '套餐C',
          policyNumber: 'POL2024003001',
          insuranceCompany: '中国人寿',
          salesPrice: '80',
          effectiveStartDate: '2024-03-15',
          effectiveEndDate: '2025-03-14',
          effectiveDate: '2024-03-15 ~ 2025-03-14',
          customerManager: '赵六',
          workLocation: ['上海市', '浦东新区'],
          projectType: '物流配送',
          billingCycle: '月度',
          accountingEntity: '顺丰速运有限公司',
          accountingSubject: '上海分公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'ZZ劳务派遣公司',
          platformInsurance: '是',
          customerService: '陈静',
          employmentType: ['劳务派遣'],
          position: ['快递员', '分拣员'],
          maxInsuranceCount: 500,
          projectAddress: ['上海市', '浦东新区'],
          addressDetail: '物流园区B区',
          policies: [
            {
              policyNo: 'POL2024003001',
              policyHolder: '顺丰速运有限公司',
              insured: ['快递员', '分拣员'],
              effectiveDate: '2024-03-15 ~ 2025-03-14',
              salesPrice: '80元/人/月',
              costPrice: '64元/人/月',
              insuranceCompany: '中国人寿',
              insuranceType: '团体意外险',
              insuranceName: '国寿团体意外伤害保险'
            }
          ]
        }
      ]
    },
    {
      id: 3,
      projectName: '广州外卖配送项目',
      customerName: '拉扎斯网络科技(上海)有限公司',
      department: ['华南运营中心', '业务部'],
      projectAddress: ['广东省', '广州市', '天河区'],
      addressDetail: '外卖运营中心',
      projectManager: '孙七',
      customerManager: '周八',
      businessType: '灵活用工',
      cooperationStatus: '合作中',
      industry: '外卖配送',
      actualEmployer: '平台',
      remark: '蜂鸟众包骑手保险',
      createTime: '2024-03-10T09:00:00Z',
      updateTime: '2024-03-10T09:00:00Z',
      children: [
        {
          id: 301,
          productName: '骑手意外险D款',
          insurancePackage: '套餐D',
          policyNumber: 'POL2024004001',
          insuranceCompany: '新华保险',
          salesPrice: '60',
          effectiveStartDate: '2024-04-01',
          effectiveEndDate: '2025-03-31',
          effectiveDate: '2024-04-01 ~ 2025-03-31',
          customerManager: '周八',
          workLocation: ['广州市', '天河区'],
          projectType: '外卖配送',
          billingCycle: '月度',
          accountingEntity: '拉扎斯网络科技(上海)有限公司',
          accountingSubject: '华南分部',
          enabled: true,
          isExpired: false,
          actualEmployer: 'AA劳务派遣公司',
          platformInsurance: '是',
          customerService: '吴小丽',
          employmentType: ['众包'],
          position: ['众包骑手'],
          maxInsuranceCount: 2000,
          projectAddress: ['广东省', '广州市', '天河区'],
          addressDetail: '外卖运营中心',
          policies: [
            {
              policyNo: 'POL2024004001',
              policyHolder: '拉扎斯网络科技(上海)有限公司',
              insured: ['蜂鸟众包骑手'],
              effectiveDate: '2024-04-01 ~ 2025-03-31',
              salesPrice: '60元/人/月',
              costPrice: '48元/人/月',
              insuranceCompany: '新华保险',
              insuranceType: '团体意外险',
              insuranceName: '新华团体意外伤害保险'
            }
          ]
        }
      ]
    },
    {
      id: 4,
      projectName: '深圳金融企业团险项目',
      customerName: '招商银行股份有限公司',
      department: ['华南运营中心', '业务部'],
      projectAddress: ['广东省', '深圳市', '福田区'],
      addressDetail: '招商银行大厦',
      projectManager: '吴九',
      customerManager: '郑十',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '金融',
      actualEmployer: '客户',
      remark: '银行员工综合保障计划',
      createTime: '2024-04-05T11:00:00Z',
      updateTime: '2024-04-05T11:00:00Z',
      children: [
        {
          id: 401,
          productName: '金融员工综合保障',
          insurancePackage: '套餐B',
          policyNumber: 'POL2024002002',
          insuranceCompany: '平安保险',
          salesPrice: '200',
          effectiveStartDate: '2024-05-01',
          effectiveEndDate: '2025-04-30',
          effectiveDate: '2024-05-01 ~ 2025-04-30',
          customerManager: '郑十',
          workLocation: ['深圳市', '福田区'],
          projectType: '金融服务',
          billingCycle: '年度',
          accountingEntity: '招商银行股份有限公司',
          accountingSubject: '华南分部',
          enabled: true,
          isExpired: false,
          actualEmployer: 'BB人力外包公司',
          platformInsurance: '否',
          customerService: '吴强',
          employmentType: ['正式员工'],
          position: ['全体员工'],
          maxInsuranceCount: 5000,
          projectAddress: ['广东省', '深圳市', '福田区'],
          addressDetail: '招商银行大厦',
          policies: [
            {
              policyNo: 'POL2024002002',
              policyHolder: '招商银行股份有限公司',
              insured: ['全体正式员工'],
              effectiveDate: '2024-05-01 ~ 2025-04-30',
              salesPrice: '200元/人/月',
              costPrice: '160元/人/月',
              insuranceCompany: '平安保险',
              insuranceType: '团体健康险',
              insuranceName: '平安高端团体健康保险'
            }
          ]
        }
      ]
    },
    {
      id: 5,
      projectName: '杭州电商仓储项目',
      customerName: '阿里巴巴集团控股有限公司',
      department: ['华东运营中心', '业务部'],
      projectAddress: ['浙江省', '杭州市', '余杭区'],
      addressDetail: '菜鸟仓储中心',
      projectManager: '钱十一',
      customerManager: '孙十二',
      businessType: '物流保险',
      cooperationStatus: '合作中',
      industry: '物流仓储',
      actualEmployer: '平台',
      remark: '菜鸟网络仓储员工保险',
      createTime: '2024-05-15T10:00:00Z',
      updateTime: '2024-05-15T10:00:00Z',
      children: [
        {
          id: 501,
          productName: '仓储员工意外险',
          insurancePackage: '套餐A',
          policyNumber: 'POL2024001002',
          insuranceCompany: '太平洋保险',
          salesPrice: '90',
          effectiveStartDate: '2024-06-01',
          effectiveEndDate: '2025-05-31',
          effectiveDate: '2024-06-01 ~ 2025-05-31',
          customerManager: '孙十二',
          workLocation: ['杭州市', '余杭区'],
          projectType: '仓储管理',
          billingCycle: '月度',
          accountingEntity: '阿里巴巴集团控股有限公司',
          accountingSubject: '华东分部',
          enabled: true,
          isExpired: false,
          actualEmployer: 'XX人力资源有限公司',
          platformInsurance: '是',
          customerService: '黄丽',
          employmentType: ['正式员工', '临时工'],
          position: ['仓库管理员', '分拣员'],
          maxInsuranceCount: 3000,
          projectAddress: ['浙江省', '杭州市', '余杭区'],
          addressDetail: '菜鸟仓储中心',
          policies: [
            {
              policyNo: 'POL2024001002',
              policyHolder: '阿里巴巴集团控股有限公司',
              insured: ['仓储员工', '分拣员'],
              effectiveDate: '2024-06-01 ~ 2025-05-31',
              salesPrice: '90元/人/月',
              costPrice: '72元/人/月',
              insuranceCompany: '太平洋保险',
              insuranceType: '团体意外险',
              insuranceName: '太平洋团体意外伤害保险'
            }
          ]
        }
      ]
    },
    {
      id: 6,
      projectName: '成都制造业项目',
      customerName: '成都制造有限公司',
      department: ['西南运营中心', '业务部'],
      projectAddress: ['四川省', '成都市', '武侯区'],
      addressDetail: '工业园区',
      projectManager: '周十三',
      customerManager: '吴十四',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '制造',
      actualEmployer: '客户',
      remark: '工厂员工工伤保险补充',
      createTime: '2024-06-20T14:00:00Z',
      updateTime: '2024-06-20T14:00:00Z',
      children: [
        {
          id: 601,
          productName: '制造业员工保障险',
          insurancePackage: '套餐C',
          policyNumber: 'POL2024003002',
          insuranceCompany: '中国人寿',
          salesPrice: '110',
          effectiveStartDate: '2024-07-01',
          effectiveEndDate: '2025-06-30',
          effectiveDate: '2024-07-01 ~ 2025-06-30',
          customerManager: '吴十四',
          workLocation: ['成都市', '武侯区'],
          projectType: '制造业',
          billingCycle: '季度',
          accountingEntity: '成都制造有限公司',
          accountingSubject: '北京总公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'ZZ劳务派遣公司',
          platformInsurance: '否',
          customerService: '李杰',
          employmentType: ['正式员工'],
          position: ['全体员工'],
          maxInsuranceCount: 800,
          projectAddress: ['四川省', '成都市', '武侯区'],
          addressDetail: '工业园区',
          policies: [
            {
              policyNo: 'POL2024003002',
              policyHolder: '成都制造有限公司',
              insured: ['全体员工'],
              effectiveDate: '2024-07-01 ~ 2025-06-30',
              salesPrice: '110元/人/月',
              costPrice: '88元/人/月',
              insuranceCompany: '中国人寿',
              insuranceType: '团体意外险',
              insuranceName: '国寿团体意外伤害保险'
            }
          ]
        }
      ]
    },
    {
      id: 7,
      projectName: '武汉医疗行业项目',
      customerName: '武汉同济医院',
      department: ['华中运营中心', '业务部'],
      projectAddress: ['湖北省', '武汉市', '硚口区'],
      addressDetail: '同济医院主院区',
      projectManager: '郑十五',
      customerManager: '王十六',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '医疗',
      actualEmployer: '客户',
      remark: '医护人员专项保险',
      createTime: '2024-07-10T09:30:00Z',
      updateTime: '2024-07-10T09:30:00Z',
      children: [
        {
          id: 701,
          productName: '医护人员责任险',
          insurancePackage: '套餐D',
          policyNumber: 'POL2024004002',
          insuranceCompany: '新华保险',
          salesPrice: '280',
          effectiveStartDate: '2024-08-01',
          effectiveEndDate: '2025-07-31',
          effectiveDate: '2024-08-01 ~ 2025-07-31',
          customerManager: '王十六',
          workLocation: ['武汉市', '硚口区'],
          projectType: '医疗服务',
          billingCycle: '年度',
          accountingEntity: '武汉同济医院',
          accountingSubject: '北京总公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'YY灵活用工平台',
          platformInsurance: '否',
          customerService: '周丽',
          employmentType: ['正式员工'],
          position: ['医生', '护士'],
          maxInsuranceCount: 2000,
          projectAddress: ['湖北省', '武汉市', '硚口区'],
          addressDetail: '同济医院主院区',
          policies: [
            {
              policyNo: 'POL2024004002',
              policyHolder: '武汉同济医院',
              insured: ['医生', '护士', '医技人员'],
              effectiveDate: '2024-08-01 ~ 2025-07-31',
              salesPrice: '280元/人/月',
              costPrice: '224元/人/月',
              insuranceCompany: '新华保险',
              insuranceType: '团体健康险',
              insuranceName: '新华团体医疗保险'
            }
          ]
        }
      ]
    },
    {
      id: 8,
      projectName: '南京零售连锁项目',
      customerName: '苏宁易购集团股份有限公司',
      department: ['华东运营中心', '业务部'],
      projectAddress: ['江苏省', '南京市', '玄武区'],
      addressDetail: '苏宁总部',
      projectManager: '孙十七',
      customerManager: '钱十八',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '零售',
      actualEmployer: '平台',
      remark: '门店员工保险计划',
      createTime: '2024-08-05T13:00:00Z',
      updateTime: '2024-08-05T13:00:00Z',
      children: [
        {
          id: 801,
          productName: '零售员工意外险',
          insurancePackage: '套餐A',
          policyNumber: 'POL2024001003',
          insuranceCompany: '太平洋保险',
          salesPrice: '75',
          effectiveStartDate: '2024-09-01',
          effectiveEndDate: '2025-08-31',
          effectiveDate: '2024-09-01 ~ 2025-08-31',
          customerManager: '钱十八',
          workLocation: ['南京市', '玄武区'],
          projectType: '零售',
          billingCycle: '月度',
          accountingEntity: '苏宁易购集团股份有限公司',
          accountingSubject: '华东分部',
          enabled: true,
          isExpired: false,
          actualEmployer: 'AA劳务派遣公司',
          platformInsurance: '是',
          customerService: '李晓华',
          employmentType: ['正式员工', '促销员'],
          position: ['销售', '客服'],
          maxInsuranceCount: 5000,
          projectAddress: ['江苏省', '南京市', '玄武区'],
          addressDetail: '苏宁总部',
          policies: [
            {
              policyNo: 'POL2024001003',
              policyHolder: '苏宁易购集团股份有限公司',
              insured: ['门店员工', '促销员'],
              effectiveDate: '2024-09-01 ~ 2025-08-31',
              salesPrice: '75元/人/月',
              costPrice: '60元/人/月',
              insuranceCompany: '太平洋保险',
              insuranceType: '团体意外险',
              insuranceName: '太平洋团体意外伤害保险'
            }
          ]
        }
      ]
    },
    {
      id: 9,
      projectName: '西安教育机构项目',
      customerName: '新东方教育科技集团',
      department: ['西北运营中心', '业务部'],
      projectAddress: ['陕西省', '西安市', '雁塔区'],
      addressDetail: '新东方大厦',
      projectManager: '吴十九',
      customerManager: '郑二十',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '教育',
      actualEmployer: '客户',
      remark: '教职员工保险',
      createTime: '2024-09-15T10:00:00Z',
      updateTime: '2024-09-15T10:00:00Z',
      children: [
        {
          id: 901,
          productName: '教育工作者保障险',
          insurancePackage: '套餐B',
          policyNumber: 'POL2024002003',
          insuranceCompany: '平安保险',
          salesPrice: '130',
          effectiveStartDate: '2024-10-01',
          effectiveEndDate: '2025-09-30',
          effectiveDate: '2024-10-01 ~ 2025-09-30',
          customerManager: '郑二十',
          workLocation: ['西安市', '雁塔区'],
          projectType: '教育培训',
          billingCycle: '年度',
          accountingEntity: '新东方教育科技集团',
          accountingSubject: '北京总公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'BB人力外包公司',
          platformInsurance: '否',
          customerService: '赵文静',
          employmentType: ['正式员工'],
          position: ['教师', '行政'],
          maxInsuranceCount: 3000,
          projectAddress: ['陕西省', '西安市', '雁塔区'],
          addressDetail: '新东方大厦',
          policies: [
            {
              policyNo: 'POL2024002003',
              policyHolder: '新东方教育科技集团',
              insured: ['教师', '行政人员'],
              effectiveDate: '2024-10-01 ~ 2025-09-30',
              salesPrice: '130元/人/月',
              costPrice: '104元/人/月',
              insuranceCompany: '平安保险',
              insuranceType: '团体健康险',
              insuranceName: '平安团体医疗保险'
            }
          ]
        }
      ]
    },
    {
      id: 10,
      projectName: '天津能源项目',
      customerName: '天津能源集团有限公司',
      department: ['华北运营中心', '业务部'],
      projectAddress: ['天津市', '市辖区', '和平区'],
      addressDetail: '能源大厦',
      projectManager: '王二十一',
      customerManager: '孙二十二',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '能源',
      actualEmployer: '客户',
      remark: '能源行业员工专项保险',
      createTime: '2024-10-20T11:00:00Z',
      updateTime: '2024-10-20T11:00:00Z',
      children: [
        {
          id: 1001,
          productName: '能源行业意外险',
          insurancePackage: '套餐C',
          policyNumber: 'POL2024003003',
          insuranceCompany: '中国人寿',
          salesPrice: '150',
          effectiveStartDate: '2024-11-01',
          effectiveEndDate: '2025-10-31',
          effectiveDate: '2024-11-01 ~ 2025-10-31',
          customerManager: '孙二十二',
          workLocation: ['天津市', '和平区'],
          projectType: '能源',
          billingCycle: '季度',
          accountingEntity: '天津能源集团有限公司',
          accountingSubject: '北京总公司',
          enabled: true,
          isExpired: false,
          actualEmployer: 'XX人力资源有限公司',
          platformInsurance: '否',
          customerService: '陈静',
          employmentType: ['正式员工'],
          position: ['技术', '管理'],
          maxInsuranceCount: 1500,
          projectAddress: ['天津市', '和平区'],
          addressDetail: '能源大厦',
          policies: [
            {
              policyNo: 'POL2024003003',
              policyHolder: '天津能源集团有限公司',
              insured: ['全体员工'],
              effectiveDate: '2024-11-01 ~ 2025-10-31',
              salesPrice: '150元/人/月',
              costPrice: '120元/人/月',
              insuranceCompany: '中国人寿',
              insuranceType: '团体意外险',
              insuranceName: '国寿团体意外伤害保险'
            }
          ]
        }
      ]
    },
    {
      id: 11,
      projectName: '重庆房地产项目',
      customerName: '龙湖集团控股有限公司',
      department: ['西南运营中心', '业务部'],
      projectAddress: ['重庆市', '市辖区', '渝北区'],
      addressDetail: '龙湖总部',
      projectManager: '钱二十三',
      customerManager: '周二十四',
      businessType: '企业团险',
      cooperationStatus: '已终止',
      industry: '房地产',
      actualEmployer: '客户',
      remark: '项目已结束',
      createTime: '2023-06-01T09:00:00Z',
      updateTime: '2024-05-31T17:00:00Z',
      children: [
        {
          id: 1101,
          productName: '地产员工综合险',
          insurancePackage: '套餐D',
          policyNumber: 'POL2023004001',
          insuranceCompany: '新华保险',
          salesPrice: '180',
          effectiveStartDate: '2023-07-01',
          effectiveEndDate: '2024-06-30',
          effectiveDate: '2023-07-01 ~ 2024-06-30',
          customerManager: '周二十四',
          workLocation: ['重庆市', '渝北区'],
          projectType: '房地产',
          billingCycle: '年度',
          accountingEntity: '龙湖集团控股有限公司',
          accountingSubject: '北京总公司',
          enabled: false,
          isExpired: true,
          actualEmployer: 'ZZ劳务派遣公司',
          platformInsurance: '否',
          customerService: '吴小丽',
          employmentType: ['正式员工'],
          position: ['全体员工'],
          maxInsuranceCount: 2000,
          projectAddress: ['重庆市', '渝北区'],
          addressDetail: '龙湖总部',
          policies: [
            {
              policyNo: 'POL2023004001',
              policyHolder: '龙湖集团控股有限公司',
              insured: ['全体员工'],
              effectiveDate: '2023-07-01 ~ 2024-06-30',
              salesPrice: '180元/人/月',
              costPrice: '144元/人/月',
              insuranceCompany: '新华保险',
              insuranceType: '团体健康险',
              insuranceName: '新华团体医疗保险'
            }
          ]
        }
      ]
    },
    {
      id: 12,
      projectName: '苏州电子科技项目',
      customerName: '苏州电子科技有限公司',
      department: ['华东运营中心', '业务部'],
      projectAddress: ['江苏省', '苏州市', '工业园区'],
      addressDetail: '科技产业园',
      projectManager: '吴二十五',
      customerManager: '郑二十六',
      businessType: '企业团险',
      cooperationStatus: '合作中',
      industry: '科技',
      actualEmployer: '平台',
      remark: '电子科技企业员工保险',
      createTime: '2024-11-05T14:00:00Z',
      updateTime: '2024-11-05T14:00:00Z',
      children: [
        {
          id: 1201,
          productName: '电子科技意外险',
          insurancePackage: '套餐A',
          policyNumber: 'POL2024001004',
          insuranceCompany: '太平洋保险',
          salesPrice: '100',
          effectiveStartDate: '2024-12-01',
          effectiveEndDate: '2025-11-30',
          effectiveDate: '2024-12-01 ~ 2025-11-30',
          customerManager: '郑二十六',
          workLocation: ['苏州市', '工业园区'],
          projectType: '电子科技',
          billingCycle: '月度',
          accountingEntity: '苏州电子科技有限公司',
          accountingSubject: '华东分部',
          enabled: true,
          isExpired: false,
          actualEmployer: 'AA劳务派遣公司',
          platformInsurance: '是',
          customerService: '吴强',
          employmentType: ['正式员工'],
          position: ['技术', '管理'],
          maxInsuranceCount: 600,
          projectAddress: ['江苏省', '苏州市', '工业园区'],
          addressDetail: '科技产业园',
          policies: [
            {
              policyNo: 'POL2024001004',
              policyHolder: '苏州电子科技有限公司',
              insured: ['全体员工'],
              effectiveDate: '2024-12-01 ~ 2025-11-30',
              salesPrice: '100元/人/月',
              costPrice: '80元/人/月',
              insuranceCompany: '太平洋保险',
              insuranceType: '团体意外险',
              insuranceName: '太平洋团体意外伤害保险'
            }
          ]
        }
      ]
    }
  ],

  getProjects() {
    return this.insuranceProjects
  },

  getProjectById(id) {
    return this.insuranceProjects.find(p => p.id === id)
  },

  addProject(project) {
    const newProject = {
      ...project,
      id: Math.max(0, ...this.insuranceProjects.map(p => p.id)) + 1,
      createTime: new Date().toISOString(),
      updateTime: new Date().toISOString(),
      children: project.children || []
    }
    this.insuranceProjects.push(newProject)
    return newProject
  },

  updateProject(id, updatedProject) {
    const index = this.insuranceProjects.findIndex(p => p.id === id)
    if (index !== -1) {
      this.insuranceProjects[index] = {
        ...this.insuranceProjects[index],
        ...updatedProject,
        updateTime: new Date().toISOString()
      }
      return this.insuranceProjects[index]
    }
    return null
  },

  deleteProject(id) {
    const index = this.insuranceProjects.findIndex(p => p.id === id)
    if (index !== -1) {
      return this.insuranceProjects.splice(index, 1)[0]
    }
    return null
  },

  getPoliciesByProjectId(projectId) {
    const project = this.getProjectById(projectId)
    if (!project) return []
    
    const policies = []
    if (project.children && Array.isArray(project.children)) {
      project.children.forEach(child => {
        if (child.policies && Array.isArray(child.policies)) {
          child.policies.forEach(policy => {
            policies.push({
              ...policy,
              productName: child.productName,
              insurancePackage: child.insurancePackage,
              isExpired: child.isExpired
            })
          })
        }
      })
    }
    return policies
  },

  getAllPolicies() {
    const policies = []
    this.insuranceProjects.forEach(project => {
      if (project.children && Array.isArray(project.children)) {
        project.children.forEach(child => {
          const effectiveStartDate = child.effectiveStartDate
          const effectiveEndDate = child.effectiveEndDate
          const isExpired = effectiveEndDate && new Date(effectiveEndDate) < new Date()
          
          if (child.policies && Array.isArray(child.policies)) {
            child.policies.forEach(policy => {
              policies.push({
                ...policy,
                productName: child.productName,
                insurancePackage: child.insurancePackage,
                isExpired: isExpired
              })
            })
          } else {
            policies.push({
              policyNo: child.policyNumber,
              policyHolder: project.customerName,
              insured: ['全体员工'],
              effectiveDate: child.effectiveDate,
              salesPrice: child.salesPrice + '元/人/月',
              costPrice: '¥' + (parseInt(child.salesPrice) * 0.8) + '/人/月',
              insuranceCompany: child.insuranceCompany,
              insuranceType: '团体意外险',
              insuranceName: '团体意外伤害保险',
              productName: child.productName,
              insurancePackage: child.insurancePackage,
              isExpired: isExpired
            })
          }
        })
      }
    })
    return policies
  }
}

export default insuranceDataSource